import React, { useCallback, useRef, useState } from 'react'
import Button from '../ui/Button'

let pyodidePromise = null

async function getPyodide() {
  if (!pyodidePromise) {
    const pyodideModuleUrl = '/vendor/pyodide/pyodide.mjs'
    pyodidePromise = import(/* @vite-ignore */ pyodideModuleUrl)
      .then(({ loadPyodide }) => loadPyodide({ indexURL: '/vendor/pyodide/' }))
  }
  return pyodidePromise
}

export default function PythonRunner({ code }) {
  const [output, setOutput] = useState('Clique em “Executar Python” para testar o código.')
  const [running, setRunning] = useState(false)
  const mountedRef = useRef(true)

  React.useEffect(() => () => {
    mountedRef.current = false
  }, [])

  const runCode = useCallback(async () => {
    setRunning(true)
    setOutput('Carregando interpretador Python local...')

    try {
      const pyodide = await getPyodide()
      const lines = []
      pyodide.setStdout({ batched: (msg) => lines.push(msg) })
      pyodide.setStderr({ batched: (msg) => lines.push(`Erro: ${msg}`) })
      await pyodide.runPythonAsync(String(code || ''))
      const text = lines.join('\n').trim() || 'Execução concluída sem saída textual.'
      if (mountedRef.current) setOutput(text)
    } catch (err) {
      if (mountedRef.current) setOutput(`Erro ao executar Python: ${err?.message || 'falha desconhecida'}`)
    } finally {
      if (mountedRef.current) setRunning(false)
    }
  }, [code])

  return (
    <div>
      <Button onClick={runCode} disabled={running}>{running ? 'Executando...' : 'Executar Python'}</Button>
      <pre style={{ width: '100%', minHeight: 240, border: '1px solid var(--line)', borderRadius: 16, marginTop: 12, background: 'white', padding: 16, overflowX: 'auto', whiteSpace: 'pre-wrap' }}>{output}</pre>
    </div>
  )
}
